import { HostClientType, HostName } from '@microsoft/teams-js';

import type { TeamsCachingContext, TeamsContext, TeamsThemeType } from './types';

/**
 * Mock Teams context for testing
 */
export const mockTeamsContext: TeamsContext = {
  appSessionId: 'test-session-id',
  entityId: 'test-entity-id',
  hostClientType: HostClientType.web,
  hostAppName: HostName.teams,
  locale: 'en-US',
  ringId: '1',
  sessionId: 'test-session-id',
  subEntityId: 'test-sub-entity-id',
  userClickTime: 123456789,
  deepLinkPath: '/test/path',
  theme: 'default' as TeamsThemeType,
  appLaunchId: 'test-launch-id',
  isBackgroundLoad: false,
  userId: 'test-user-id',
  tenantId: 'test-tenant-id',
};

/**
 * Mock Teams caching context for testing
 */
export const mockTeamsCachingContext: TeamsCachingContext = {
  isCached: true,
};

/**
 * Mock initial state for testing
 */
export const mockInitialState = {
  teamsContext: undefined,
  teamsCachingContext: {
    isCached: false,
  },
};
